import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

const LoginPage = () => {
  const { login, isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, loading, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-pulse text-slate-400">Caricamento...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col lg:flex-row relative">
      {/* Full background image - visible on mobile */}
      <div className="absolute inset-0 lg:hidden">
        <img
          src="/club-bg.jpg"
          alt="Ananda Sporting Club"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/40" />
      </div>

      {/* Left side - Image (desktop only) */}
      <div className="hidden lg:flex lg:w-1/2 relative">
        <img
          src="/club-bg.jpg"
          alt="Ananda Sporting Club"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-sky-500/20 to-transparent" />
        <div className="absolute bottom-12 left-12 text-white">
          <h2 className="font-outfit text-4xl font-semibold mb-2 drop-shadow-lg">
            Ananda Sport
          </h2>
          <p className="text-lg text-white/90 drop-shadow">
            Il tuo circolo di tennis
          </p>
        </div>
      </div>

      {/* Right side - Login form */}
      <div className="relative flex-1 flex items-center justify-center p-8 lg:bg-slate-50">
        <div className="w-full max-w-md">
          {/* Mobile logo */}
          <div className="lg:hidden text-center mb-12">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white/15 backdrop-blur-md rounded-2xl mb-4 ring-1 ring-white/20">
              <svg className="w-8 h-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <circle cx="12" cy="12" r="10" strokeWidth="2" />
                <path strokeWidth="2" d="M12 2C12 12 12 12 22 12" />
                <path strokeWidth="2" d="M12 22C12 12 12 12 2 12" />
              </svg>
            </div>
            <h1 className="font-outfit text-3xl font-semibold text-white drop-shadow-lg">
              Ananda Sport
            </h1>
          </div>

          {/* Login card */}
          <div className="bg-white/10 backdrop-blur-xl rounded-3xl p-8 border border-white/20 shadow-2xl lg:bg-white lg:border-slate-100 lg:backdrop-blur-none lg:shadow-[0_4px_20px_rgb(0,0,0,0.03)]">
            <div className="text-center mb-8">
              <h2 className="font-outfit text-2xl font-semibold text-white lg:text-slate-900 mb-2">
                Benvenuto
              </h2>
              <p className="text-white/60 lg:text-slate-500">
                Accedi per organizzare le tue partite
              </p>
            </div>

            <button
              onClick={login}
              data-testid="google-login-btn"
              className="w-full flex items-center justify-center gap-3 px-6 py-4 bg-white rounded-full font-medium text-slate-900 hover:bg-white/90 lg:hover:bg-slate-50 transition-all hover:-translate-y-0.5 hover:shadow-md lg:border lg:border-slate-200"
            >
              <svg className="w-5 h-5" viewBox="0 0 24 24">
                <path
                  fill="#4285F4"
                  d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                />
                <path
                  fill="#34A853"
                  d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                />
                <path
                  fill="#FBBC05"
                  d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                />
                <path
                  fill="#EA4335"
                  d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                />
              </svg>
              Continua con Google
            </button>

            <p className="mt-6 text-center text-sm text-white/40 lg:text-slate-400">
              Accedendo, accetti i nostri termini di servizio
            </p>
          </div>

          {/* Footer */}
          <p className="mt-8 text-center text-sm text-white/30 lg:text-slate-400">
            © 2025 Ananda Sport. Tutti i diritti riservati.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
